import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { ConversationDto } from '@/Domain/api/Conversation/dto/Conversation.dto';
import { Separator } from '@/Domain/components/Shared/Separator/Separator';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/Domain/components/Shared/Tooltip/Tooltip';

type Props = {
  conversation: ConversationDto;
};

export const UnifiedTopic = ({ conversation }: Props) => {
  const { t } = useTranslation('inbox_v2');

  const unifiedAnalysis = conversation.unified_analysis;

  if (!unifiedAnalysis || !unifiedAnalysis.topic) {
    return (
      <>
        <Separator />
        <Tooltip>
          <div className="flex flex-col gap-2">
            <section className="text-foreground-subtle flex gap-1">
              <p className="font-semibold text-foreground-subtle">
                {t('conversation_details.topic.title')}
              </p>
              <TooltipTrigger>
                <Icon icon="mingcute:information-line" />
              </TooltipTrigger>
              <TooltipContent className="absolute left-3 -translate-y-14 -translate-x-1/3 w-[200px]">
                {t('tooltip.topic')}
              </TooltipContent>
            </section>
            <p className="text-foreground-subtle loading-text">
              {t('conversation_details.unified_analytics.pending')}
            </p>
          </div>
        </Tooltip>
      </>
    );
  }

  return (
    <>
      <Separator />
      <Tooltip>
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between gap-2">
            <section className="text-foreground-subtle flex gap-1">
              <p className="font-semibold text-foreground-subtle">
                {t('conversation_details.topic.title')}
              </p>
              <TooltipTrigger>
                <Icon icon="mingcute:information-line" />
              </TooltipTrigger>
              <TooltipContent className="absolute left-3 -translate-y-14 -translate-x-1/3 w-[200px]">
                {t('tooltip.topic')}
              </TooltipContent>
            </section>
          </div>
          <div>
            <p className="text-foreground-subtle">{unifiedAnalysis.topic}</p>
          </div>
        </div>
      </Tooltip>
    </>
  );
};
